
export const loadVar = (name: string):any => getEnv()[`VUE_APP_${name}`] || getWindow()[name];
const getWindow = () => (window as any).config || {};
const getEnv = () => (process as any).env || {};